import {
  NEW_EVENT_REQUEST,
  NEW_EVENT,
  NEW_EVENT_ERROR,
  GET_EVENT_REQUEST_LOAD,
  GET_EVENT_REQUEST_LOAD_SUCCESS,
  GET_EVENT_REQUEST,
  GET_EVENT,
  GET_EVENT_ERROR,
  DELETE_EVENT_REQUEST,
  DELETE_EVENT,
  DELETE_EVENT_ERROR,
} from '../actions/types'

var initialState = {
  item: {},
  loading: true,
  error: {},
}

export default function(state = initialState, action) {
  switch (action.type) {
    case NEW_EVENT_REQUEST:
      return {
        ...state,
        loading: action.payload.loading,
      }
    case NEW_EVENT:
      return {
        ...state,
        item: action.payload.event,
      }
    case NEW_EVENT_ERROR:
      return {
        ...state,
        error: action.payload.error,
      }
    case GET_EVENT_REQUEST_LOAD:
      return {
        ...state,
        loading: action.payload.loading,
      }
    case GET_EVENT_REQUEST_LOAD_SUCCESS:
      return {
        ...state,
        loading: action.payload.loading,
      }
    case GET_EVENT_REQUEST:
      return {
        ...state,
        loading: action.payload.loading,
      }
    case GET_EVENT:
      return {
        ...state,
        loading: action.payload.loading,
        item: action.payload.event,
      }
    case GET_EVENT_ERROR:
      return {
        ...state,
        loading: action.payload.loading,
        error: action.payload.error,
      }
    case DELETE_EVENT_REQUEST:
      return {
        ...state,
        loading: action.payload.loading,
      }
    case DELETE_EVENT:
      return {
        ...state,
        loading: action.payload.loading,
        item: action.payload.event,
      }
    case DELETE_EVENT_ERROR:
      return {
        ...state,
        loading: action.payload.loading,
        error: action.payload.error,
      }
    default:
      return {
        ...state,
      }
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/event_reducer.js
 **/